import { CheckIcon, HourglassIcon, ProhibitIcon, ThumbsUpIcon, TruckIcon } from '@phosphor-icons/react'

import {
  deliveryMethods,
  ShipmentOutForDeliveryIcon,
  shipmentStatuses,
  shipmentStatusLabels,
} from '@reveni-io/reveni-ui'

import { returnStatusLabels, trackingTypes } from './constants'

export const getDateByStatus = (info, status) => {
  let dateByStatus = null

  if (status === shipmentStatuses.ready) {
    dateByStatus = info?.ready_at
  }

  if (status === shipmentStatuses.shipped) {
    dateByStatus = info?.shipped_at
  }

  if (status === shipmentStatuses.out_for_delivery) {
    dateByStatus = info?.out_for_delivery_at
  }

  if (status === shipmentStatuses.delivered) {
    dateByStatus = info?.delivered_at
  }

  if (status === shipmentStatuses.cancelled) {
    dateByStatus = info?.cancelled_at
  }

  if (dateByStatus) return new Date(dateByStatus)
}

export const getDateAndHour = (info, language, status, timeZone) => {
  let dateToShow = getDateByStatus(info, status)
  let date = null
  let hour = null

  if (dateToShow) {
    hour = new Intl.DateTimeFormat(language, {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: timeZone || undefined,
    }).format(dateToShow)

    date = new Intl.DateTimeFormat(language, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: timeZone || undefined,
    }).format(dateToShow)
  }
  return { date, hour }
}

export const getIconInfoByTypeAndStatus = (type, status, theme) => {
  if (type === trackingTypes.shipment || type === trackingTypes.fulfillment) {
    return getShippingStatusIconInfo(theme)[status]
  } else if (type === trackingTypes.return) {
    return getReturnStatusIconInfo(theme)[status]
  }
}

export const getStatusLabel = (type, status, deliveryMethod) => {
  if (type === trackingTypes.shipment || type === trackingTypes.fulfillment) {
    return shipmentStatusLabels[status]
  } else if (type === trackingTypes.return) {
    if (status === shipmentStatuses.ready && deliveryMethod === deliveryMethods.customerpickup) {
      return returnStatusLabels.customerpickup
    }

    return returnStatusLabels[status]
  }
}

export const getShippingStatusIconInfo = theme => {
  return {
    [shipmentStatuses.ready]: {
      icon: ThumbsUpIcon,
      backgroundColor: theme.colors.blue.tone500,
      color: theme.colors.white,
    },
    [shipmentStatuses.shipped]: {
      icon: TruckIcon,
      backgroundColor: theme.colors.blue.tone500,
      color: theme.colors.white,
    },
    [shipmentStatuses.out_for_delivery]: {
      icon: ShipmentOutForDeliveryIcon,
      backgroundColor: theme.colors.blue.tone500,
      color: theme.colors.white,
    },
    [shipmentStatuses.delivered]: {
      icon: CheckIcon,
      backgroundColor: theme.colors.green.tone500,
      color: theme.colors.white,
    },
    [shipmentStatuses.cancelled]: {
      icon: ProhibitIcon,
      backgroundColor: theme.colors.grey.tone900,
      color: theme.colors.white,
    },
  }
}

export const getReturnStatusIconInfo = theme => {
  return {
    [shipmentStatuses.ready]: {
      icon: HourglassIcon,
      backgroundColor: theme.colors.pink.tone300,
      color: theme.colors.black,
    },
    [shipmentStatuses.shipped]: {
      icon: TruckIcon,
      backgroundColor: theme.colors.blue.tone500,
      color: theme.colors.white,
    },
    [shipmentStatuses.delivered]: {
      icon: CheckIcon,
      backgroundColor: theme.colors.green.tone500,
      color: theme.colors.white,
    },
    [shipmentStatuses.cancelled]: {
      icon: ProhibitIcon,
      backgroundColor: theme.colors.grey.tone900,
      color: theme.colors.white,
    },
  }
}
